import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 10.5996L13.5996 12L9 7.40039L4.40039 12L3 10.5996L9 4.59961L15 10.5996Z" }));
export default SvgArrowUp;
